import Events from "../../Utils/EventLite";
import DOMActor from "../../Libs/Vexr/DOMActor";
import Screen from "../../Utils/Screen";
import PumpkinTemplate from "../Pumpkin.ejs";

export default class SelectedPumpkin extends DOMActor{
    constructor (data) {
        super("SelectedPumpkin", Screen.getAnchor("center"));
        this.element.innerHTML = PumpkinTemplate(data);

        var parent = document.getElementById("SelectedPumpkin");
        while (parent.firstChild) {
            parent.removeChild(parent.firstChild);
        }
        this.addToParent(parent);
        this.setPosition();
        Events.on("resize", this.setPosition.bind(this));
        this.render();
    }
    setPosition (e) {
        this.location = Screen.getAnchor("center");
        this.render();
    }
}


// WEBPACK FOOTER //
// ./src/views/Components/SelectedPumpkin.js